(function() {

  const check = document.querySelector('.archive-content-agenda');

  if( check ) {

    // ArchiveControler + config

    const news_controler = new ArchiveControler();
      news_controler.register_archive_container( document.getElementById('ArchiveAgenda') );
      news_controler.register_self_loading_classname('agenda__loading');
      news_controler.register_more_button_classname('button__more');
  }

})();